import instance from '@src/api/axiosInstance';
import { useQuery } from '@tanstack/react-query';
import { get } from 'lodash';


const useGetSessions = ({ open }) => {
    const { data = [], isFetching, isError } = useQuery(['nexa-sessions'],
      async () => {
        const response = await instance.get('/nexa/sessions');
        return get(response, ['data', 'sessions'], []);
      },
      {
        enabled: open,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 10 * 1000, // 10s
        notifyOnChangeProps: ['isFetching', 'isError', 'data']
      }
    );

    return { data, isFetching, isError };
}

export default useGetSessions;
